import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

const getCounterpartiesTypes = async () => {
  const data = await request.get(
    `/RentPlace/counterparty/type`,
    {},
    'При загрузке типов контрагентов произошла ошибка',
    []
  );
  return data;
};

const useCounterpartiesTypes = () =>
  useQuery([queries.counterpartiesTypes], () => getCounterpartiesTypes(), {
    placeholderData: [],
  });

export default useCounterpartiesTypes;
